import { useLocalSearchParams } from 'expo-router';

/**
 * Explicit unavailable deeplink target for section chrome.
 * Set by PDP → section redirects; marketing `targetItemIds` pins alone do not set this.
 */
export const useUnavailableItemId = (): string | undefined => {
  const { unavailableItemId } = useLocalSearchParams<{ unavailableItemId?: string | string[] }>();

  if (!unavailableItemId) {
    return undefined;
  }

  const raw = Array.isArray(unavailableItemId) ? unavailableItemId[0] : unavailableItemId;
  const id = raw?.trim();
  return id || undefined;
};
